document.addEventListener('DOMContentLoaded', function () {
  var video = document.getElementById('Mp4Video-template--27910202491211__hero_video_fBkLYD');
  if (!video) return;

  var desktopSrc = 'https://cdn.shopify.com/videos/c/o/v/42e182e73bd44197a62b5fa2a47188d0.mp4';
  var mobileSrc  = 'https://cdn.shopify.com/videos/c/o/v/8d8a5d20011f4956876b1d65739c8e8e.mp4';

  function setVideoSource() {
    var isMobile = window.innerWidth <= 600;
    var desiredSrc = isMobile ? mobileSrc : desktopSrc;

    if (video.getAttribute('src') !== desiredSrc) {
      video.pause();
      video.setAttribute('src', desiredSrc);
      video.load();
      video.play().catch(function () {});
    }
  }

  setVideoSource();
  window.addEventListener('resize', setVideoSource);
});
